import { render, staticRenderFns } from "./BotonAccion.vue?vue&type=template&id=0e96ffbc"
import script from "./BotonAccion.vue?vue&type=script&lang=js"
export * from "./BotonAccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports